<div class="videoWrap">
    <h2 class="modal-title text-center">{{videoModalTitle}}</h2>

    <div class="text-center">
        <p style="margin:0px;">{{videoModalDescription}}</p>
    </div>

    <div class="modal-body video-container" style="height: calc(100% - 177px);"></div>

    <div class="text-center">
        <div class="col-md-12">
            <button (click)="closeVideoModal()" style="min-width: 145px;" data-dismiss="modal" type="button" class="btn btn-secondary">Close</button>
        </div>
    </div>
</div>